export const currencyConfig = {
    formatAmount
};

function formatAmount(amount: string, currencyCode: any = "TND", decimalPrecision: number) {
    if (localStorage.getItem('currencies')) {
        const currency = JSON.parse(localStorage.getItem('currencies') || "");
        if (currency) {
            if (currency.symbol_position == "left") {
                return currencyCode + " " + parseFloat(amount).toFixed(decimalPrecision);
            } else {
                return parseFloat(amount).toFixed(decimalPrecision) + " " + currencyCode;
            }
        } else {
            return parseFloat(amount).toFixed(decimalPrecision) + " " + currencyCode;
        }
    } else {
        return parseFloat(amount).toFixed(decimalPrecision) + " " + currencyCode;}
}